const useStyles = theme => ({
    image:{
		width :"85px",
		height:"80px",
		maxWidth:"100%",
		display:"flex",
		flexDirection:"column",
		justifyContent:"center",
		alignItems:"center",
		border: "0.5px solid gray",
    	margin: "10px",
		padding: '5px',
   		borderRadius: "10px",
		cursor:"pointer",
		fontSize: "12px"
	},
	selectedImage:{
		width :"85px",
		height:"80px",
		maxWidth:"100%",
		display:"flex",
		flexDirection:"column",
		justifyContent:"center",
		alignItems:"center",
		border: "0.5px solid gray",
    	margin: "10px",
		padding: '5px',
   		borderRadius: "10px",
		backgroundColor:"#009F3C",
		color: "white",
		fontSize: "12px"
	},
	icon: {
		width: "40px",
		height: "40px",
		display: "block"
	},
	selectedIcon: {
		filter: "invert(1)",
		width: "40px",
		height: "40px",
		display: "block"
	}
});

export default useStyles;